import styled from "@emotion/styled";
const Separator = {
    DateSeparator: styled.div `
    display: flex;
    align-items: center;
    font-size: 0.8rem;
    margin: 1.5em 0 1em 0;
    color: ${({ theme }) => theme.color.textMuted};
    &::before,
    &::after {
      content: "";
      height: 0.08em;
      background-color: ${({ theme }) => theme.color.backgroundAccent};
      flex-grow: 1;
    }
    &::before {
      margin-right: 0.5em;
    }
    &::after {
      margin-left: 0.5em;
    }
  `,
};
export default Separator;
//# sourceMappingURL=DateSeparator.styled.js.map